import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    backgroundColor: `${theme.palette.primary.main}60`,
    width: '100%',
    height: '150px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    borderRadius: '5px',
  },
  innerBorder: {
    boxSizing: 'border-box',
    border: '3px dashed #fff',
    width: '100%',
    height: '100%',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: '#fff',
  },
}));

interface IProps {
  title?: string;
}

const PreviewDummy = (props: IProps): JSX.Element => {
  const classes = useStyles();

  const { title } = props;

  return (
    <Box className={classes.root}>
      <Box className={classes.innerBorder}>
        <Typography variant="h6" className={classes.title}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};
export default PreviewDummy;
